import { joinRouteMatchPath, interpolatePathParams, TrackedUrl } from '@futrli/shared-services';
import { capitalize } from 'lodash';
import { Location } from 'history';
import { matchPath, PathMatch } from 'react-router-dom';
import queryString from 'query-string';

export const hasBlacklistedParam = (matchingItem: TrackedUrl, locationSearch: string) => {
  if (matchingItem.params && locationSearch) {
    const urlParams = queryString.parse(locationSearch);
    const matchParams = matchingItem.params;

    return Object.keys(urlParams).some(urlParamKey => matchParams.blacklist.includes(urlParamKey));
  }

  return false;
};

export const sanitazeStr = (str = '') => str.replace(/\s+/g, '').toLocaleLowerCase();

export const findPathMatch = (item: TrackedUrl, location: Location) =>
  !!matchPath(joinRouteMatchPath('', ...item.paths), location.pathname);

/**
 * Interpolates the path params in the title in case of being specified in the
 * item.title property in the same way we do with paths
 * @param {TrackedUrl} matchingItem - Url to track.
 * @param {Location} location
 * @returns {string} Interpolated title if there are params to interpolate.
 *
 * @example
 * // Current browser location pathname: '/register/flow'
 *
 * const matchingItem =   {
 *   paths: [REGISTER_BY_PRODUCT_ROUTE],
 *   title: `Register - :${ROUTE_PARAMS.PRODUCT_SLUG}`
 * }
 *
 * getTitle(matchingItem);
 * > 'Register - Flow'
 */
export const getInterpolatedTitle = (matchingItem: TrackedUrl, location: Location) => {
  const pathMatch: PathMatch<string> | null = matchPath(
    joinRouteMatchPath('', ...matchingItem.paths),
    location.pathname
  );
  const params = pathMatch?.params;

  if (!params) {
    return matchingItem.title;
  }

  return Object.keys(params).reduce((memo: string, paramKey: string) => {
    return interpolatePathParams(memo, { [paramKey]: capitalize(params[paramKey]) });
  }, matchingItem.title);
};
